module.exports = __webpack_public_path__ + "img/user-lock-solid.6f1c7bdf.svg";